import PropTypes from "prop-types";

export const HelpSearchPropTypes = {
  defaultResultsLang: PropTypes.string.isRequired,
};
